import { __assign, __read, __values } from "tslib";
import { isKey, WhereOperator, QueryExpType, } from '@tencent/memoire-core';
import { KeyIntervalGroup } from './key-interval';
// QueryRewriter take a raw query from user, transform to query exp
var QueryRewriter = /** @class */ (function () {
    function QueryRewriter(comparer) {
        this.comparer = comparer;
    }
    /**
     * Rewrite the user-provided query into a `QueryConditions` object
     * @param raw An original query from users
     * @returns A `QueryConditions` object expressed the query in an query expression tree
     */
    QueryRewriter.prototype.rewrite = function (raw) {
        return {
            offset: raw.offset,
            limit: raw.limit,
            order: raw.order && __assign({}, raw.order),
            exp: this.rewriteWhereClauses(raw.whereClauses),
        };
    };
    QueryRewriter.prototype.rewriteWhereClauses = function (whereClauses) {
        var e_1, _a, e_2, _b, _c;
        if (!whereClauses.length) {
            return { type: QueryExpType.ALL };
        }
        var exp = { type: QueryExpType.OR, exps: [] };
        try {
            for (var whereClauses_1 = __values(whereClauses), whereClauses_1_1 = whereClauses_1.next(); !whereClauses_1_1.done; whereClauses_1_1 = whereClauses_1.next()) {
                var clause = whereClauses_1_1.value;
                // all clauses inside a predicate are wrapped in AND
                var and = { type: QueryExpType.AND, exps: [] };
                try {
                    for (var _d = (e_2 = void 0, __values(Object.entries(clause))), _e = _d.next(); !_e.done; _e = _d.next()) {
                        var _f = __read(_e.value, 2), path = _f[0], maybeKey = _f[1];
                        // ignore undefined predicate
                        if (maybeKey === undefined) {
                            continue;
                        }
                        var predicate = isKey(maybeKey)
                            ? // if the predicate is just a key, take it as an equal predicate
                             (_c = {}, _c[WhereOperator.Equals] = maybeKey, _c) : maybeKey;
                        // ignore empty predicate
                        if (this.isEmptyPredicate(predicate)) {
                            continue;
                        }
                        and.exps.push({
                            type: QueryExpType.FILTER,
                            predicate: predicate,
                            path: path,
                            hints: {
                                intervalGroup: KeyIntervalGroup.fromWherePredicate(predicate, this.comparer),
                                isKey: false,
                                indices: [],
                            },
                        });
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
                exp.exps.push(and);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (whereClauses_1_1 && !whereClauses_1_1.done && (_a = whereClauses_1.return)) _a.call(whereClauses_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return exp;
    };
    // check whether the predicate is an empty object
    QueryRewriter.prototype.isEmptyPredicate = function (predicate) {
        return Object.values(predicate).every(function (value) { return value === undefined; });
    };
    return QueryRewriter;
}());
export default QueryRewriter;
//# sourceMappingURL=query-rewriter.js.map